module.exports = __webpack_public_path__ + "assets/img/icon_usdr.2043d612.png";